import type { EmployerBidListBid } from "@js/types/jobs";

import { deselectAllBids, selectBids } from "./bid-bulk-selection-slice";

export const useBidSelectionCheckbox = (
  allBidsSelected: boolean,
  bidList: EmployerBidListBid[],
) => {
  if (allBidsSelected) {
    return deselectAllBids;
  }
  return () => selectBids(bidList.map((bid) => bid.id));
};
